import { FETCH_AUTO_NURTURE_FAILURE, FETCH_AUTO_NURTURE_REQUEST, FETCH_AUTO_NURTURE_SUCCESS, UPDATE_AUTO_NURTURE_STAT } from "../../actions/autoNurture/autoNurtureActions";
import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../../actions/commonActions";

  const initialState = {
    autoNurtureLoading: true,
    autoNurtureData: [],
    autoNurtureError: null,
  };
  
  
  const autoNurtureReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_AUTO_NURTURE_REQUEST:
        return { ...state, autoNurtureLoading: true , payload: action.payload};
      case FETCH_AUTO_NURTURE_SUCCESS:
        return { ...state, autoNurtureLoading: false, autoNurtureData: action.payload };
      case FETCH_AUTO_NURTURE_FAILURE:
        return { ...state, autoNurtureLoading: false, autoNurtureError: action.payload };    
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
              return initialState ;
      case UPDATE_AUTO_NURTURE_STAT:
        return {
        ...state,
        autoNurtureData: state.autoNurtureData?.map(item =>
          item._id === action.payload.campId
            ? { ...item, active_status: action.payload.activeStatus }
            : item
        )
      };
   

      default:
        return state;
    }
  };
  
  export default autoNurtureReducer;
  
